import { createSvgIcon } from "@mui/material/utils";

/**
 * Info icon.
 *
 * ![InfoIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi40IC0yLjQgMjQuOCAyNC44IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZjtib3JkZXItcmFkaXVzOjRweCI+PGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIzMTRfMTEyMDcpIj48cGF0aCBkPSJNMTAuMDAxMyA2LjY2NjVWOS45OTk4NE0xMC4wMDEzIDEzLjMzMzJIMTAuMDA5Nk0xOC4zMzQ2IDkuOTk5ODRDMTguMzM0NiAxNC42MDIyIDE0LjYwMzcgMTguMzMzMiAxMC4wMDEzIDE4LjMzMzJDNS4zOTg5MyAxOC4zMzMyIDEuNjY3OTcgMTQuNjAyMiAxLjY2Nzk3IDkuOTk5ODRDMS42Njc5NyA1LjM5NzQ2IDUuMzk4OTMgMS42NjY1IDEwLjAwMTMgMS42NjY1QzE0LjYwMzcgMS42NjY1IDE4LjMzNDYgNS4zOTc0NiAxOC4zMzQ2IDkuOTk5ODRaIiBzdHJva2U9IiMxMDE4MjgiIHN0cm9rZS13aWR0aD0iMS42NjY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48L3BhdGg+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iY2xpcDBfMjMxNF8xMTIwNyI+PHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSI+PC9yZWN0PjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==)
 */
const InfoIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2314_11207)">
      <path
        d="M10.0013 6.6665V9.99984M10.0013 13.3332H10.0096M18.3346 9.99984C18.3346 14.6022 14.6037 18.3332 10.0013 18.3332C5.39893 18.3332 1.66797 14.6022 1.66797 9.99984C1.66797 5.39746 5.39893 1.6665 10.0013 1.6665C14.6037 1.6665 18.3346 5.39746 18.3346 9.99984Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2314_11207">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  "Info"
);

export default InfoIcon;
